import { StateInterface } from 'client/Interfaces/StateInterface'
// typescript
import { SubscriptionManagementStateInterface } from 'client/Interfaces/Subscription/ReduxStateInterfaces'
import { createSelector } from 'reselect'

export const subscriptionManagementSelector = createSelector(
  (state: Pick<StateInterface, 'subscriptionManagement'>) => state.subscriptionManagement,
  (subscriptionManagement): SubscriptionManagementStateInterface => subscriptionManagement,
)
